import { IApplicationState } from '../../../types/redux';

export const selectUrlsData = (state: IApplicationState) => {
  return state.mainpage.urls;
};
